import { render, staticRenderFns } from "./AdminMIS.vue?vue&type=template&id=4608060a"
import script from "./AdminMIS.vue?vue&type=script&lang=js"
export * from "./AdminMIS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports